import { render, staticRenderFns } from "./OrgSettingsConfig.vue?vue&type=template&id=bf4f73fc&scoped=true&"
import script from "./OrgSettingsConfig.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsConfig.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsConfig.vue?vue&type=style&index=0&id=bf4f73fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4f73fc",
  null
  
)

export default component.exports